module.exports = __webpack_public_path__ + "media/images/sport--default-b9f73c92061f4bf094e3cbf9acbcd984.png";